import dayjs from 'dayjs';

export const leaveApplicationValidation = {
  employeeId: {
    required: 'Please select an employee',
  },
  leaveType: {
    required: 'Please select a leave type',
  },
  startDate: {
    required: 'Please select a start date',
    validate: (value) => {
      if (!value) return true;

      const today = dayjs().startOf('day');
      const start = dayjs(value).startOf('day');

      return start.isSame(today) || start.isAfter(today) || 'Start date cannot be in the past';
    },
  },
  startSession: {
    required: 'Please select a start date session',
  },
  endDate: (startDate) => ({
    validate: (value) => {
      if (!value) return true;

      const today = dayjs().startOf('day');
      const end = dayjs(value).startOf('day');
      const start = startDate ? dayjs(startDate).startOf('day') : null;

      if (end.isSame(today) || end.isBefore(today)) {
        return 'End date must be a future date';
      }

      if (start && end.isSame(start)) {
        return 'End date must be later than the start date';
      }

      if (start && end.isBefore(start)) {
        return 'End date cannot be earlier than the start date';
      }

      return true;
    },
  }),
  endSession: {
    validate: (value, { endDate }) => {
      if (!endDate) return true;
      return value ? true : 'Please select an end date session';
    },
  },
  reason: {
    required: 'Please enter a reason for the leave application',
    minLength: {
      value: 3,
      message: 'Leave application reason should be minimum 3 characters',
    },
    maxLength: {
      value: 600,
      message: 'Leave application reason cannot be more than 600 characters',
    },
  },
  attachment: { required: false },
};
